export default __webpack_public_path__ + "static/media/news23.22c3bb24.jpg";